import type { ReactPageFunction } from '../../js/cloudflare/types';
import { storeAPI } from '../../js/config';
import HeaderFooterLayout from '../../js/layout/HeaderFooterLayout';
import type { StaticLayoutProps } from '../../js/layout/Layout';
import type { StoreWithOpeningHours } from '../../js/model/types';
import type { Props } from '../../js/stores/StoreDetailsPage';
import StoreDetailsPage from '../../js/stores/StoreDetailsPage';
import { setCacheControl } from '../../js/utils/responseHelpers';

export const onRequestGet: ReactPageFunction<'/butikk/[id]', Props> = async ({ params, data, next, renderToResponse, request }) => {
    const storeId = params.id;
    const res = await data.fetchFromBackend(storeAPI.storeURL(storeId) + '?fields=FULL');

    if (res.status === 404) return next();

    if (res.status !== 200) throw new Error(`Request to ${storeAPI.storeURL(storeId)} responded with ${res.status}`);

    const store = await res.json<StoreWithOpeningHours>().catch(() => undefined);

    if (!store) return next();

    return renderToResponse({
        store,
        url: request.url,
    }).then(setCacheControl(`public, max-age=${5 * 60}, stale-while-revalidate=${60 * 60 * 24}`));
};

export function StaticLayout({ props }: StaticLayoutProps<Props>) {
    const title = `Vinmonopolets butikk - ${props.store.displayName}`;
    const description = `Vinmonopolets butikk på ${props.store?.address?.line1}, ${props.store.address?.postalCode} ${props.store.address?.town}. Se åpningstider og hva som er forventet trafikk.`;
    return (
        <HeaderFooterLayout
            className="page-storeinformation"
            title={title}
            page_title="Butikk"
            meta={[{ name: 'description', content: description }]}
        />
    );
}

export default function ({ store, url }: Props) {
    return <StoreDetailsPage store={store} url={url} />;
}
